<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import { selectedGroup } from '../store';
    import http from '../api/http.js';
    import {Button, Modal, ModalBody, ModalFooter, ModalHeader, CustomInput } from 'sveltestrap';
    let shown =false;
    const dispatch = createEventDispatcher();
    const toggle = () => (shown = !shown);
    let endpoint;
   
    export async function show(endpointArg) {
        endpoint = endpointArg;
        shown = true;
    }

    async function forgetEndpoint() {
        const res = await http.put(window.apiBaseUrl + `/deploy/dashboard/vessels/endpoint/${endpoint.id}/${$selectedGroup}`);
        if (res.ok) {
            dispatch('endpointForgotten');
            shown = false;
        }
    }

    function _onYes() {  
        forgetEndpoint();
        shown = false;
    }    
   
    function _onNo() {
        shown = false;
    }
   </script>
   
   <Modal isOpen={shown} {toggle}>
       <ModalHeader {toggle}>
           Forget Endpoint
       </ModalHeader>
       <ModalBody>
           <p>Are you sure you want forget this endpoint <strong class="text-info">{endpoint.macAddress}</strong>?</p>
           <p class="text-danger"><i class="fa fa-exclamation-triangle"></i> If this endpoint is detected on your network in the future it will return.</p> 
       </ModalBody>
       <ModalFooter>
            <button id="forget-endpoint-cancel-button" class="btn btn-outline-primary" on:click={() => _onNo()}>Cancel</button>
           <button id="forget-endpoint-confirm-button" on:click={() => _onYes()} class="btn btn-primary">Confirm</button>
       </ModalFooter>
    </Modal>
